enum ThunkDebugName {
  GetRedisUtils = 'GET_REDIS_UTILS',
  GetServerPropsCached = 'GET_SERVER_PROPS_CACHED',
  CheckIsPreviewMode = 'CHECK_IS_PREVIEW_MODE',
  GetAllEventsAndArticles = 'GET_ALL_EVENTS_AND_ARTICLES',
}

export default ThunkDebugName;
